/* eslint-disable no-undef */
/* eslint-disable no-constant-condition */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Fragment, useCallback, useEffect, useState } from 'react';
import React from 'react';
import { useDropzone } from 'react-dropzone'
import { Grid, Box } from '@mui/material';

import './Personal.scss';
import PaymentDetails from './PaymentDetails';
import PaymentDetailsNew from './PaymentDetailsNew';
import { useDispatch, useSelector } from 'react-redux';
import { getSession, setSelectedShipping } from '../../reducers/user-reducers/UserSlicer';
import { snackbarToggle } from '../../reducers/snackbarSlicer';
import { copyToClipboard1, shipping_upload, get_parcel_logs } from '../../reducers/requestHandler';

import upload from '../../images/upload.png'
import DialogWithSideBar from '../../style-guide/Dialog/DialogWithSideBar';
import Loader from '../../style-guide/Loader';
import { FaCheck } from "react-icons/fa";

export const PersonalDetails = ({isPersonal, setIsPersonal}) => {
    //const { isPersonal, setIsPersonal } = props;
    const { userInfo, selectedShipping } = useSelector(state => state.user);
    const [activeScreen, setActiveScreen] = useState(1);
    const [isFileUploaded, setIsFileUploaded] = useState(true);
    const dispatch = useDispatch();
    const [logs, setLogs] = useState([]);
    const [maxLog, setMaxLog] = useState(0);

    const getStatusObj = (arr, idInArr, idInStatus) => {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].id == idInArr) {
                var ar1 = JSON.parse(JSON.stringify(arr[i]))
                ar1.id = idInStatus;
                return ar1;
            }
        }
        return null;
    }

    useEffect(() => {
        if (selectedShipping.clientStatus == null) {
            setLogs(selectedShipping?.params?.statusLog);
        } else {
            get_parcel_logs(selectedShipping.hawb, userInfo.session, function (data) {
                var lgs = [];
                var log = 0;
                var id1Exists = false, id2Exists = false, id3Exists = false, id4Exists = false, id5Exists = false, id6Exists = false, id7Exists = false, id9Exists = false;
                for (var i = 0; i < data.length; i++) {
                    if (data[i].stage > log)
                        log = data[i].stage;
                    if (data[i].stage == 1)
                        id1Exists = true;
                    if (data[i].stage == 2)
                        id2Exists = true;
                    if (data[i].stage == 3)
                        id3Exists = true;
                    if (data[i].stage == 4)
                        id4Exists = true;
                    if (data[i].stage == 5)
                        id5Exists = true;
                    if (data[i].stage == 6)
                        id6Exists = true;
                    if (data[i].stage == 7)
                        id7Exists = true;
                    if (data[i].stage == 9) {
                        id9Exists = true;
                    }
                    lgs.push({ DATE: data[i].createdDate, DESC: data[i].data, id: data[i].stage, stage: data[i].stage });
                }
                var ml = 0;
                switch (log) {
                    case 0:
                        ml = 0;
                        //setMaxLog(0);
                        break;
                    case 1:
                        ml = 0;
                        //setMaxLog(0);
                        break;
                    case 2:
                        ml = 1;
                        //setMaxLog(1);
                        break;
                    case 3:
                        ml = 1;
                        //setMaxLog(1);
                        break;
                    case 4:
                        ml = 1;
                        //setMaxLog(1);
                        break;
                    case 5:
                        ml = 2;
                        //setMaxLog(2);
                        break;
                    case 6:
                        ml = 3;
                        //setMaxLog(3);
                        break;
                    case 7:
                        ml = 3;
                        //setMaxLog(3);
                        break;
                    case 8:
                        ml = 4;
                        //setMaxLog(4);
                        break;
                    case 9:
                        ml = 4;
                        //setMaxLog(4);
                        break;
                    case 10:
                        ml = 5;
                        //setMaxLog(5);
                        break;
                    default:
                        ml = 0;
                        //setMaxLog(0);
                        break;
                }
                if (selectedShipping.clientStatus > ml) {
                    setMaxLog(selectedShipping.clientStatus);
                } else {
                    setMaxLog(ml);
                }
                if (selectedShipping.shippingStatus == 6)
                    setMaxLog(5);
                var obj = null;
                if (!id1Exists) {
                    obj = getStatusObj(selectedShipping?.params?.statusLog, 1, 1);
                    if (obj)
                        lgs.push(obj);
                    if (!id4Exists) {
                        obj = getStatusObj(selectedShipping?.params?.statusLog, 2, 4);
                        if (obj)
                            lgs.push(obj);
                        if (!id7Exists) {
                            obj = getStatusObj(selectedShipping?.params?.statusLog, 5, 7);
                            if (obj)
                                lgs.push(obj);
                        }
                    }
                }
                lgs.sort(function (b, a) {
                    return new Date(a.DATE).getTime() - new Date(b.DATE).getTime();
                });
                setLogs(lgs);
            });
        }
    }, [selectedShipping, userInfo]);
    const checkFiles = function () {
        if (uploadedOrgFiles?.length >= selectedShipping?.trackListOfConsolidation?.length && selectedShipping?.consolidationStatus == 3) {
           // dispatch(snackbarToggle({ type: 'error', message: `All files are uploaded.` }));
            return true;
        }
        return false;
    }
    
    const onDrop = useCallback(acceptedFiles => {

        setIsFileUploaded(false)
        var formData = new FormData();
        var bUpload = true;
        acceptedFiles.forEach((file) => {

            var fileSize = Math.round((file.size / 1024));

            if (fileSize <= 2 * 1024) {
                // alert("Uploaded");
            } else {

                // return;
                bUpload = false;
            }

            if (bUpload) {
                formData.append("file", file, file.name);
                const reader = new FileReader()

                reader.onabort = () => {
                    dispatch(snackbarToggle({ type: 'error', message: `Not a proper file` }));
                    return;
                }
                reader.onerror = () => {
                    dispatch(snackbarToggle({ type: 'error', message: `Not a proper file` }));
                    return;
                }
                reader.onload = () => {
                    // Do whatever you want with the file contents
                    const binaryStr = reader.result

                }
                reader.readAsArrayBuffer(file)
            }
        })

        if (bUpload) {

            formData.append("shippingReqId", parseInt(selectedShipping?.id));
            formData.append("reportProgress", true);
            formData.append("sessionId", userInfo.session);
            shipping_upload(formData, function (response) {
                //console.log(response)
                if (response) {
                    var data = response?.data;
                    if (data?.paramsNew) {
                        data.params = JSON.parse(data.paramsNew);
                        dispatch(setSelectedShipping(data));
                    }
                }
                if (response?.misc?.CODE == 2) {
                    dispatch(snackbarToggle({ type: 'error', message: "Upload Proper file" }));
                    setIsFileUploaded(true)
                } else {
                    setIsFileUploaded(true)
                    setUploadedOrgFiles(response?.data?.params?.userData?.reciept_org_names ? response?.data?.params?.userData?.reciept_org_names?.split(",") : [])
                }

            });
        } else {
            setIsFileUploaded(true)
            dispatch(snackbarToggle({ type: 'error', message: `ניתן להעלות קבצים מסוג JPEG, PNG, BMP, PDF עד גודל 2MB` }));
        }


    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        accept: {
            'image/png': ['.png'],
            'image/jpeg': ['.jpeg'],
            'image/bmp': ['.bmp'],
            'application/pdf': ['.pdf']

        }, onDrop
    })

    const copyToClipboard = (text) => {
        copyToClipboard1(text, function (data) {
            dispatch(snackbarToggle({ type: 'success', message: data }));

            window.setTimeout(function () { dispatch(snackbarToggle(false)); }, 2000);
        })
    }
    
    const [uploadedOrgFiles, setUploadedOrgFiles] = useState([]);

    const getStatusById = (id) => {
        if (selectedShipping.clientStatus != null) {
            var id1 = id;
            if (id > 3)
                id1 = id - 2;
            return maxLog >= id1;
        } else {
            for (var i = 0; i < selectedShipping?.params?.statusLog?.length; i++) {
                if (selectedShipping?.params?.statusLog[i].id == id) {
                    return selectedShipping?.params?.statusLog[i].DATE;
                }
            }
        }
        return false;
    }
    const getNewStatusById = (id) => {
        if (selectedShipping.clientStatus != null) {
            var id1 = id;
            return maxLog == id1;
        }
        return false;
    }
    const getDateFormat = (e) => {
        var date = new Date(e);
        var dat = ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate()));
        var month = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)));
        var date_formated = dat + '/' + month + '/' + date.getFullYear().toString().slice(-2) + "  " + date.getHours() + ":" + (date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes());
        return date_formated
    }
    const isKiosk = (data) => {
        return !data.params.homeDelivary && data.params.homeDelivary_nis == 0;
    }
    const getCity = (data) => {
        return data.params?.userPaymentData?.destPickup?.City;
    }
    const getStreet = (data) => {
        return data.params?.userPaymentData?.destPickup?.Street;
    }
    const getHome = (data) => {
        return data.params?.userPaymentData?.destPickup?.House;
    }
    return (

        <DialogWithSideBar
            open={isPersonal}

            onClose={() => {
                setIsPersonal(false)
            }}
            isBackButton={activeScreen == 4 || activeScreen == 5 || activeScreen == 6}
            onClickBack={() => setActiveScreen(activeScreen - 1)}
        >

            {
                !isFileUploaded ? <Loader /> :
                <Box className="reg_popup_data">
                    {(selectedShipping?.shippingStatus == 201 || (selectedShipping?.shippingStatus == 203 && (selectedShipping?.oldShippingStatus == 1 || selectedShipping?.oldShippingStatus == 2))) ?
                        <Grid className="popup_tittle lg" style={{ marginTop: "250px" }} >{`.צור קשר עם שרות לקוחות`}</Grid>
                        :
                        <Grid container itme style={{}}>
                            <Grid item container style={{ direction: "rtl", fontWeight: "bold", fontSize: "23px", color: "#FF3452" }} justifyContent="flex-start">
                                {`חבילה מס׳`} {selectedShipping.hawb}
                            </Grid>
                            <Grid container item lg={12} className='label-wrapper' style={{ marginTop: '20px' }}>
                                <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: 0 }}>
                                    תשלום
                                </Grid>
                            </Grid>


                            <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '0', direction: 'rtl' }}>
                                {(selectedShipping.shippingStatus != 203 || (selectedShipping.shippingStatus == 203 && (selectedShipping.oldShippingStatus == 3 || selectedShipping.oldShippingStatus == 4 || selectedShipping.oldShippingStatus == 5))) && < Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '0', direction: 'rtl' }}>
                                    <PaymentDetails userInfo={userInfo} selectedShipping={selectedShipping} />
                                    {selectedShipping?.params?.oldPayments?.length && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '2vh !important' }}>
                                        <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: '8px' }}>
                                            {`תשלומים נוספים :`}
                                        </Grid>
                                        {selectedShipping?.params?.oldPayments.map(dt => <PaymentDetailsNew info={dt.curPayment} totalNIS={dt.totalNIS} totalUSD={dt.totalUSD} showItemsTitle={false} />)}
                                    </Grid>}
                                    <Grid item container style={{ marginTop: "30px" }} flexDirection="column" alignItems="flex-start">
                                        <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: 0 }}>
                                            {`כתובת למשלוח`}
                                        </Grid>
                                        {isKiosk(selectedShipping) && <Grid style={{ marginTop: "10px" }}>
                                            <p style={{ fontWeight: "bold", margin: 0 }}>{`נקודת איסוף`}</p>
                                            <p style={{ margin: 0 }}>{getCity(selectedShipping)}</p>
                                            <p style={{ margin: 0 }}>{getStreet(selectedShipping)}</p>
                                            <p style={{ margin: 0 }}>{getHome(selectedShipping)}</p>
                                        </Grid>}
                                        {!isKiosk(selectedShipping) && getCity(selectedShipping) && <Grid style={{ marginTop: "10px" }}>
                                            <p style={{ margin: 0 }}>{getCity(selectedShipping)}, {getStreet(selectedShipping)} {getHome(selectedShipping)}</p>
                                        </Grid>}
                                    </Grid>
                                </Grid>}
                                {selectedShipping.shippingStatus == 302 && <Box className="dropzone-area" style={{ marginTop: "2vh" }} >
                                    {/*{<Box className="dropzone-area" >*/}
                                    <Grid container className="upload-content">
                                        <div {...getRootProps({
                                            onClick: (event) => {
                                                if (checkFiles()) {
                                                    event.stopPropagation();
                                                }
                                            }
                                        })} className='upload-area'>
                                            <input {...getInputProps()} />
                                            {
                                                <Grid container className="upload-content">
                                                    <img className='upload' src={upload} alt='upload' />
                                                    {selectedShipping.consolidationStatus == 3 && uploadedOrgFiles?.length > 0 && !checkFiles() && <Box className="content-line-1">
                                                        ניתן להעלות מספר חשבוניות
                                                    </Box>}
                                                    {selectedShipping.consolidationStatus == 3 && uploadedOrgFiles?.length > 0 && checkFiles() && <Box className="content-line-1">
                                                        החשבוניות עלו בהצלחה
                                                    </Box>}
                                                    <Box className="content-line-1" style={{ direction: "rtl", textAlign: "right" }}>
                                                        {`להעלאת חשבונית הקנייה`} <a style={{ textDecoration: "underline", color: "#FF3452" }}>{`לחץ כאן`}</a> {`>>>`}
                                                    </Box>
                                                    <Box className="content-line-1" style={{ direction: "rtl" }}>
                                                        <span>
                                                            ניתן להעלות קבצים מסוג JPEG, PNG, BMP, PDF עד גודל 2MB
                                                        </span>
                                                        <p style={{ marginTop: "15px" }}>
                                                            {`על החשבונית לכלול את הפרטים הבאים: שם המוכר, שם הקונה, תיאור המוצרים ועלותם. מומלץ להעלות כקובץ PDF`}
                                                        </p>
                                                    </Box>
                                                </Grid>
                                            }
                                        </div>
                                    </Grid>
                                </Box>}
                                {selectedShipping?.params?.statusLog && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '4vh !important' }}>
                                    <Grid container item lg={12} className='label-wrapper' style={{ marginTop: '24px' }}>
                                        <Grid className="popup_tittle sm" style={{ fontSize: '23px', marginBottom: 0 }}>
                                            פרטים
                                        </Grid>
                                    </Grid>
                                    {false && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ mt: '3vh !important' }}>
                                            {selectedShipping.clientStatus == null ? <Grid flexWrap="nowrap" container className="screen-progress-steps" style={{ justifyContent: 'flex-start' }}>
                                                <Box className={`progress-step1 ${(getStatusById(1) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${(getStatusById(1) ? 'red_back' : '')}`}>
                                                        {getStatusById(1) ? <FaCheck /> : 1}
                                                    </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit" }}>
                                                        {"תשלום"}
                                                    </Box>

                                                </Box>
                                                {/*<hr class="divider" />*/}
                                                <Box className={`progress-step1 ${(getStatusById(2) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${(getStatusById(2) ? 'red_back' : '')}`} >
                                                        {getStatusById(2) ? <FaCheck /> : 2}
                                                    </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit" }}>
                                                        {"המשלוח בטיפול"}
                                                    </Box>
                                                </Box>
                                                {/* <hr class="divider" />*/}
                                                <Box className={`progress-step1 ${(getStatusById(3) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${(getStatusById(3) ? 'red_back' : '')}`}>
                                                        {getStatusById(3) ? <FaCheck /> : 3}
                                                    </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit" }}>
                                                        {`בדרך לארץ`}
                                                    </Box>
                                                </Box>
                                                <Box className={`progress-step1 ${getStatusById(6) ? 'done_back' : ''}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${getStatusById(6) ? 'red_back' : ''}`}>
                                                        {getStatusById(6) ? <FaCheck /> : 4} {/*5*/}
                                                    </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit" }}>
                                                        {"נמסר להפצה"}
                                                    </Box>
                                                </Box>
                                                {/*<hr class="divider" />*/}
                                                <Box className={`progress-step1 ${(getStatusById(7) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${(getStatusById(7) ? 'red_back' : '')}`}>
                                                        {getStatusById(7) ? <FaCheck /> : 5} {/*6*/}
                                                    </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit" }}>
                                                        {"משלוח נמסר"}
                                                    </Box>
                                                </Box>
                                            </Grid> : <Grid flexWrap="nowrap" container className="screen-progress-steps" style={{ justifyContent: 'flex-start' }}>
                                                <Box className={`progress-step1 ${(getStatusById(1) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${(getStatusById(1) ? 'red_back' : '')}`}>
                                                        {getStatusById(1) ? <FaCheck /> : 1}
                                                        </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit", fontWeight: `${getNewStatusById(0) ? 'bold' : ''}`, color: `${getNewStatusById(0) ? '#FF3452' : ''}` }}>
                                                        {"תשלום"}
                                                    </Box>

                                                </Box>
                                                {/*<hr class="divider" />*/}
                                                <Box className={`progress-step1 ${(getStatusById(2) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${(getStatusById(2) ? 'red_back' : '')}`} >
                                                        {getStatusById(2) ? <FaCheck /> : 2}
                                                        </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit", fontWeight: `${getNewStatusById(1) ? 'bold' : ''}`, color: `${getNewStatusById(1) ? '#FF3452' : ''}` }}>
                                                        {"בטיפול"}
                                                    </Box>
                                                </Box>
                                                {/* <hr class="divider" />*/}
                                                <Box className={`progress-step1 ${(getStatusById(3) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${(getStatusById(3) ? 'red_back' : '')}`}>
                                                        {getStatusById(3) ? <FaCheck /> : 3}
                                                        </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit", fontWeight: `${getNewStatusById(2) ? 'bold' : ''}`, color: `${getNewStatusById(2) ? '#FF3452' : ''}` }}>
                                                        {"בדרך לארץ"}
                                                    </Box>
                                                </Box>
                                                <Box className={`progress-step1 ${getStatusById(6) ? 'done_back' : ''}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${getStatusById(6) ? 'red_back' : ''}`}>
                                                        {getStatusById(6) ? <FaCheck /> : 4} {/*5*/}
                                                        </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit", fontWeight: `${getNewStatusById(3) ? 'bold' : ''}`, color: `${getNewStatusById(3) ? '#FF3452' : ''}` }}>
                                                        {"בתהליך מכס"}
                                                    </Box>
                                                </Box>
                                                {/*<hr class="divider" />*/}
                                                <Box className={`progress-step1 ${(getStatusById(7) ? 'done_back' : '')}`} style={{ marginTop: "10px" }}>
                                                    <Box className={`step-circle ${(getStatusById(7) ? 'red_back' : '')}`}>
                                                        {getStatusById(7) ? <FaCheck /> : 5} {/*6*/}
                                                        </Box>
                                                    <Box className="step-title" style={{ textAlign: "inherit", fontWeight: `${getNewStatusById(4) ? 'bold' : ''}`, color: `${getNewStatusById(4) ? '#FF3452' : ''}` }}>
                                                        {"הפצה"}
                                                    </Box>
                                                </Box>
                                            </Grid>}
                                    </Grid>}
                                    <Grid container item lg={12} spacing={1} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                        <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                            תאריך
                                        </Grid>
                                        <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                            תיאור
                                        </Grid>
                                    </Grid>
                                    {logs?.map((val, index) => <>
                                        {(val.DESC && (val.id == 3 && selectedShipping?.parentId == 0 ? selectedShipping?.params?.shippingStatus : true)) && <Grid container item lg={12} spacing={1} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                            <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                                {getDateFormat(val.DATE)}
                                            </Grid>
                                            <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                                {val.DESC}
                                            </Grid>
                                        </Grid>
                                        }
                                    </>)}
                                    {selectedShipping.parentId == 0 && <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                        <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                            {getDateFormat(selectedShipping.create_date)}
                                        </Grid>
                                        <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                            {`ההזמנה נקלטה במערכת`} {selectedShipping?.parentId == 0 ? " - ORCA Market" : ""}
                                        </Grid>
                                    </Grid>}
                                </Grid>}
                                {(selectedShipping.consolidationStatus == 3 && !selectedShipping?.params?.notes?.includes("Repack Service:")) &&

                                    <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                        <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                            איחוד חבילות:
                                        </Grid>
                                        <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                            {selectedShipping?.params?.notes?.replace("Repack:", "").replaceAll("Old", "Original")}
                                        </Grid>
                                    </Grid>
                                }
                                {false && selectedShipping.repackStatus == 104 &&

                                    <Grid container item lg={12} justifyContent="flex-start" alignContent="flex-start" sx={{ borderBottom: '1px solid gray', mt: '2vh !important' }}>
                                        <Grid container item lg={3} xs={3} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                            צמצום נפח:
                                        </Grid>
                                        <Grid container item lg={9} xs={9} justifyContent="flex-start" alignContent="flex-start" sx={{ fontWeight: 'bold' }}>
                                            {selectedShipping?.params?.notes?.replace("Repack:", "").replaceAll("Old", "Original")}
                                        </Grid>
                                    </Grid>
                                }
                                <Grid style={{ height: "90vh" }}></Grid>
                            </Grid>
                        </Grid>}
                </Box>
            }
            
        </DialogWithSideBar>
    );
}

export default PersonalDetails;